import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { TYPOGRAPHY } from "@store/theme/common/design";
import { contentSpacingStyles, titleSpacingStyles } from "@store/theme/common/mixins";
import polyfillCss from "@store/theme/common/polyfillCss";
import breakpointValuesMediaQueries from "@store/Framework/Common/Utilities/breakpointValuesMediaQueries";

export default {
    fontFamilyImportUrl: "", // https://use.typekit.net/ppu3jda.css - workaround in HeadEnd.tsx
    body: {
        fontFamily: TYPOGRAPHY.fontFamily.base,
        lineHeight: TYPOGRAPHY.lineHeight.base,
        size: TYPOGRAPHY.size.smaller,
        weight: TYPOGRAPHY.weight.base,
    },
    legend: {
        size: TYPOGRAPHY.size.veryTiny,
        weight: TYPOGRAPHY.weight.bold,
        color: "text.accent",
        transform: "uppercase",
    },
    p: {
        size: "inherit",
        weight: "inherit",
        css: polyfillCss`
            ${contentSpacingStyles()}
        `,
    },
    h1: {
        size: 26,
        weight: TYPOGRAPHY.weight.black,
        color: "text.titles",
        lineHeight: 1.2,
        transform: "uppercase",
        css: polyfillCss`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, 26, 30, null, null], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    h2: {
        size: 16,
        weight: TYPOGRAPHY.weight.black,
        color: "text.titles",
        lineHeight: 1.25,
        transform: "uppercase",
        css: polyfillCss`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, 20, 22, null, null], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    h3: {
        size: 20,
        weight: TYPOGRAPHY.weight.bold,
        color: "text.titles",
        lineHeight: 1.3,
        css: polyfillCss`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, 21, 29, null, 30], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    h4: {
        size: 18,
        weight: TYPOGRAPHY.weight.medium,
        color: "text.titles",
        lineHeight: 1.3,
        css: polyfillCss`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, 21, null, 26], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    h5: {
        size: 16,
        weight: TYPOGRAPHY.weight.black,
        lineHeight: 1.3,
        css: polyfillCss`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, 18, null, 21], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    h6: {
        size: 16,
        weight: TYPOGRAPHY.weight.black,
        lineHeight: 1.3,
        css: polyfillCss`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, 17, null, 20], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    headerPrimary: {
        size: 28,
        weight: TYPOGRAPHY.weight.bold,
        color: "text.titles",
        lineHeight: 1.3,
        transform: "inherit",
        css: polyfillCss`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, 30, null, 48], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    headerSecondary: {
        size: 14,
        weight: TYPOGRAPHY.weight.bold,
        lineHeight: 1.3,
        transform: "inherit",
        css: polyfillCss`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, 14, null, 16], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
};
